import { betrag } from "../format";
import { brennt, type Spalte } from "./lage";
import { achse, FRISTEN_TEXTE } from "./saetze";

/** Säulen des Fristen-Moduls (E10, DESIGN-W82 „Fristen-Modul“): 194 hoch, fünf Rasterlinien, Spalten „vorbei“ und vier
 *  Wochen, zwischen „vorbei“ und der ersten Woche die Heute-Spalte (14 breit, gestrichelte Linie, Heute-Pille). Säule
 *  30 x 104, Ecke 11, Grund `spur`; Segmente je Frist gestapelt (dringendste unten, Lücke 2, Ecke 10), darüber die
 *  Wochensumme der offenen Beträge (leer bei 0), darunter die Formen-Zeile und die Achse. Die Rasterlinien zeichnet jede
 *  Spalte selbst, nur neben ihrer Säule (D-434, welt.css). Nur Grafik (`aria-hidden`), die Textfassung steht daneben
 *  (`diagrammText`). Beim Auftritt wachsen die Säulen der Reihe nach (welt.css). */
export function Saeulen(props: { spalten: Spalte[] }) {
  const vorbeiBrennt = brennt(props.spalten.slice(0, 1));
  return (
    <div className="diagramm-rahmen" aria-hidden="true">
    <div className="diagramm" data-testid="saeulen">
      <div className="spalten">
        {props.spalten.map((s, b) => (
          <SpalteMitHeute key={s.bis ?? "vorbei"} spalte={s} b={b} brennt={b === 0 && vorbeiBrennt} />
        ))}
      </div>
    </div>
    </div>
  );
}

function SpalteMitHeute(props: { spalte: Spalte; b: number; brennt: boolean }) {
  const s = props.spalte;
  return (
    <>
      {props.b === 1 && (
        <div className="heute-spalte" data-testid="heute">
          <span className="heute-pille w-pille">{FRISTEN_TEXTE.heute}</span>
        </div>
      )}
      <div className="spalte" data-art={s.art} data-brennt={props.brennt ? "" : undefined} style={{ "--b": props.b } as React.CSSProperties} data-testid={`spalte-${props.b}`}>
        <span className="s-summe" data-testid={`summe-${props.b}`}>
          {s.summe > 0 ? betrag(s.summe) : ""}
        </span>
        <div className="saeule">
          <div className="fuell">
            {s.segmente.map((x) => (
              <i key={x.ids.join("+")} className="seg" data-zustand={x.zustand} data-frist={x.ids[0]} style={{ height: `${x.hoehe}px` }} />
            ))}
          </div>
        </div>
        {/* Lücke 5 aus der Vorlage (D-434), kein Vielfaches des 2-px-Rasters */}
        <span className="punkte" data-raster-ausnahme="formen-zeile">
          {s.segmente.map((x) => (
            <i key={x.ids.join("+")} className="pk" data-zustand={x.zustand} />
          ))}
        </span>
        <span className="achse w-achse">{achse(s.bis)}</span>
      </div>
    </>
  );
}
